<app-header></app-header>
<app-whatsapp-credits-alert />
<router-outlet>
  <div *ngIf="loading" data-testid="loading-panel" class="background-panel">
    <app-loading-box></app-loading-box>
  </div>
</router-outlet>
<app-version-update-banner
  *ngIf="showUpdateBanner"
  [releaseMessage]="releaseMessage"
  (update)="onApplyUpdate()"
  (dismissed)="onDismissUpdate()"
></app-version-update-banner>
<app-token-refresh-modal *ngIf="sessionExpired"></app-token-refresh-modal>
<app-connection-expired-modal *ngIf="connectionExpired"></app-connection-expired-modal>
